import getEnv from './getEnv'

const urls = {
  // local: 'http://localhost:4001',
  // local: 'https://api.galaxy.orionx.com',
  local: 'https://api.andromeda.orionx.com',
  dev: 'https://api.andromeda.orionx.com',
  castor: 'https://api.castor.orionx.com',
  pollux: 'https://api.pollux.orionx.com',
  beta: 'https://api-beta.galaxy.orionx.com',
  prod: 'https://api.galaxy.orionx.com',
}

const env = getEnv()

export default urls[env]
